import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'invoice-classes';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
